import React, { memo } from 'react'
import { HiOutlineDocumentText } from 'react-icons/hi'
import Button from 'shared/components/Button'
import Text from 'shared/components/Text'
import { colors } from 'shared/styles/colors'
import intersect from 'shared/assets/images/intersect.png'

import { Container } from '../../Pagamento/styles'
import { ContainerIcon, ContainerContent, StyledModal } from './styles'
interface IModalContaEmAnaliseProps {
  openModalContaEmAnalise: boolean
  setOpenModalContaEmAnalise(state: boolean): void
  openModalSelectCnpj(): void
  clerSelectedFrotista(): void
}

const ModalContaEmAnalise = ({
  openModalContaEmAnalise,
  setOpenModalContaEmAnalise,
  openModalSelectCnpj,
  clerSelectedFrotista,
}: IModalContaEmAnaliseProps) => {
  return (
    <>
      <StyledModal
        img={intersect}
        openModal={openModalContaEmAnalise}
        size="small"
        showCloseButton={true}
        onCloseModal={() => {
          setOpenModalContaEmAnalise(false)
          clerSelectedFrotista()
          openModalSelectCnpj()
        }}
      >
        <Container>
          <ContainerIcon>
            <HiOutlineDocumentText color="white" />
          </ContainerIcon>

          <ContainerContent>
            <Text size={24} weight="700" color={colors.black}>
              Verificando os dados
            </Text>
            <Text size={14} weight="400" color={colors.gray}>
              Sua conta está em análise, iremos te comunicar por e-mail assim
              que terminarmos de verificar seus dados.
            </Text>
          </ContainerContent>
          <Button
            style={{ width: '100%' }}
            color={colors.green}
            onClick={() => {
              setOpenModalContaEmAnalise(false)
              openModalSelectCnpj()
            }}
          >
            Voltar
          </Button>
        </Container>
      </StyledModal>
    </>
  )
}

export default memo(ModalContaEmAnalise)
